import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateReplacementSendCloudShipmentMutationVariables = Types.Exact<{
  order_id: Types.Scalars['ID'];
}>;


export type CreateReplacementSendCloudShipmentMutation = { __typename?: 'Mutation', createReplacementSendCloudShipment: { __typename?: 'ReplacementShipmentResult', order_id: string, created: boolean, shipment_attempt_number: number, tracking_numbers: Array<string>, labels_url?: string | null, status: Types.MerchantOrderStatusEnum } };


export const CreateReplacementSendCloudShipmentDocument = gql`
    mutation CreateReplacementSendCloudShipment($order_id: ID!) {
  createReplacementSendCloudShipment(order_id: $order_id) {
    order_id
    created
    shipment_attempt_number
    tracking_numbers
    labels_url
    status
  }
}
    `;
export type CreateReplacementSendCloudShipmentMutationFn = Apollo.MutationFunction<CreateReplacementSendCloudShipmentMutation, CreateReplacementSendCloudShipmentMutationVariables>;

/**
 * __useCreateReplacementSendCloudShipmentMutation__
 *
 * To run a mutation, you first call `useCreateReplacementSendCloudShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplacementSendCloudShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplacementSendCloudShipmentMutation, { data, loading, error }] = useCreateReplacementSendCloudShipmentMutation({
 *   variables: {
 *      order_id: // value for 'order_id'
 *   },
 * });
 */
export function useCreateReplacementSendCloudShipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateReplacementSendCloudShipmentMutation, CreateReplacementSendCloudShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReplacementSendCloudShipmentMutation, CreateReplacementSendCloudShipmentMutationVariables>(CreateReplacementSendCloudShipmentDocument, options);
      }
export type CreateReplacementSendCloudShipmentMutationHookResult = ReturnType<typeof useCreateReplacementSendCloudShipmentMutation>;
export type CreateReplacementSendCloudShipmentMutationResult = Apollo.MutationResult<CreateReplacementSendCloudShipmentMutation>;
export type CreateReplacementSendCloudShipmentMutationOptions = Apollo.BaseMutationOptions<CreateReplacementSendCloudShipmentMutation, CreateReplacementSendCloudShipmentMutationVariables>;